/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { CATEGORY_DEFAULT_OPTION } from "../../../util/consts";
import { Product } from "../storage";

export const getFilterCategories = (data: Product[] | undefined | null) => {
  const unique = [...new Set(data?.map((x) => x.category))].sort((a, b) => a?.localeCompare(b));
  unique.unshift(CATEGORY_DEFAULT_OPTION);
  return unique;
};
